import {vpost} from "@/util/post";

export const eventtype = {
    list(pageSize, pageCurrent, key = "", dealerId = null) {
        return vpost("/eventtype/list", {pageSize, pageCurrent, key, dealerId});
    },
    detail(id) {
        return vpost("/eventtype/detail?id=" + id);
    },
    create(dto) {
        return vpost("/eventtype/create", dto);
    },
    update(dto) {
        return vpost("/eventtype/update", dto);
    },
    delete(id) {
        return vpost("/eventtype/delete?id=" + id);
    },
};
